import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SnLabel from "@shared/components/SnLabel";
import SnComboBox from "@shared/components/SnComboBox";
import SnTextBox from "@shared/components/SnTextBox";
import SnCheckBox from "@shared/components/SnCheckBox";

export interface Popup002Ref {
  checkValidity: () => Promise<{ flag: boolean; message?: string }>;
  getSelectedValue: () => Promise<any>;
}

const SN_SFA_ISSUE_REG_005_POP_005 = forwardRef<Popup002Ref>((props, ref) => {
  const serverCode = useRef<string>("");
  const [test, setTest] = useState<boolean>(true);

  useImperativeHandle(ref, () => ({
    async checkValidity() {
      if (!test && !serverCode.current) {
        return { flag: false, message: "배포 서버를 입력해 주세요." };
      }

      return { flag: true };
    },

    async getSelectedValue() {
      return {
        serverCode: test ? "http://112.175.88.51:7003" : serverCode.current,
      };
    },
  }));

  return (
    <div className="flex flex-col w-full space-y-2">
      <div className="flex items-center space-x-2">
        <SnLabel text="테스트 서버" type="string" />
        <SnCheckBox
          defaultValue={test ? "Y" : "N"}
          onValueChanged={(val) => setTest(val == "Y")}
        />
      </div>

      <div className="flex items-center space-x-2">
        <SnLabel text="배포 서버" type="string" />
        <SnTextBox
          onValueChanged={(val) => (serverCode.current = val)}
          isReadOnly={test}
        />
      </div>
    </div>
  );
});

export default SN_SFA_ISSUE_REG_005_POP_005;
